import { AdminNotePriority } from '../../enums';

export interface CreateAdminNoteDto {
  category: string; // Required, max 50
  content: string; // Required, max 2000
  isInternal?: boolean; // Default true
  priority?: AdminNotePriority; // Default Normal
}
